module.exports = __webpack_public_path__ + "fonts/interactive.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/interactive.ttf
// module id = 58
// module chunks = 0